import {   GET_JOBS_DETAIL_ADMINTOOLS, GET_JOBS_OPTION_ADMINTOOLS, RESET_JOBS_DETAIL_ADMINTOOLS} from "shared/constants/ActionTypes";

const initialState = {
  optionJobs: null,
  detailJobs:null
};

const jobsAdmintoolsReducer = (state = initialState, action) => {
  switch (action.type) {
  
      case GET_JOBS_DETAIL_ADMINTOOLS:
        return {
          ...state,
          detailJobs: action.payload,
        };
        case GET_JOBS_OPTION_ADMINTOOLS:
            return {
              ...state,
              optionJobs: action.payload,
            };
        default: {
          return state;
        }

        case RESET_JOBS_DETAIL_ADMINTOOLS:
          return initialState
  }
};

export default jobsAdmintoolsReducer;
